(function() {
  function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
      get: v,
      set: s,
      enumerable: true,
      configurable: true
    });
  }
  var $parcel$global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
  var $parcel$modules = {};
  var $parcel$inits = {};
  var parcelRequire = $parcel$global["parcelRequire5f74"];
  if (parcelRequire == null) {
    parcelRequire = function(id) {
      if (id in $parcel$modules) {
        return $parcel$modules[id].exports;
      }
      if (id in $parcel$inits) {
        var init = $parcel$inits[id];
        delete $parcel$inits[id];
        var module = {
          id: id,
          exports: {}
        };
        $parcel$modules[id] = module;
        init.call(module.exports, module, module.exports);
        return module.exports;
      }
      var err = new Error("Cannot find module '" + id + "'");
      err.code = "MODULE_NOT_FOUND";
      throw err;
    };
    parcelRequire.register = function register(id, init) {
      $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire5f74"] = parcelRequire;
  }
  var parcelRegister = parcelRequire.register;
  parcelRegister("cJzMp", function(module, exports) {
    $parcel$export(module.exports, "createLogger", function() {
      return $94557121a748c06f$export$fe2e61603b61130d;
    });
    $parcel$export(module.exports, "serializeError", function() {
      return $94557121a748c06f$export$46ff38bc6bdea8fb;
    });
    $parcel$export(module.exports, "withDebugReason", function() {
      return $94557121a748c06f$export$4ecc6b6d3cd743de;
    });
    const $94557121a748c06f$var$LS_KEY = "mbf_debug";
    const $94557121a748c06f$var$CATEGORIES = [ "lifecycle", "events", "network", "ui", "animation", "errors" ];
    const $94557121a748c06f$var$CATEGORY_STYLES = {
      lifecycle: "color:#6366f1;font-weight:bold",
      events: "color:#10b981;font-weight:bold",
      network: "color:#3b82f6;font-weight:bold",
      ui: "color:#f59e0b;font-weight:bold",
      animation: "color:#ec4899;font-weight:bold",
      errors: "color:#ef4444;font-weight:bold"
    };
    const $94557121a748c06f$var$FILE_STYLE = "color:#94a3b8;font-style:italic";
    const $94557121a748c06f$var$LABEL_STYLE = "color:#475569";
    const $94557121a748c06f$var$BATCH_WINDOW_MS = 120;
    const $94557121a748c06f$var$GROUPED_LOG_RULES = [ {
      file: "tagalys-helpers",
      category: "ui"
    } ];
    const $94557121a748c06f$var$groupedLogBuffers = new Map;
    const $94557121a748c06f$var$groupedLogTimers = new Map;
    function $94557121a748c06f$var$defaultConfig() {
      const categories = {};
      $94557121a748c06f$var$CATEGORIES.forEach(c => categories[c] = true);
      return {
        enabled: false,
        categories: categories,
        files: {}
      };
    }
    function $94557121a748c06f$var$load() {
      try {
        const raw = localStorage.getItem($94557121a748c06f$var$LS_KEY);
        if (!raw) return $94557121a748c06f$var$defaultConfig();
        const parsed = JSON.parse(raw);
        const cfg = $94557121a748c06f$var$defaultConfig();
        cfg.enabled = !!parsed.enabled;
        if (parsed.categories && typeof parsed.categories === "object") Object.keys(cfg.categories).forEach(k => {
          if (k in parsed.categories) cfg.categories[k] = !!parsed.categories[k];
        });
        if (parsed.files && typeof parsed.files === "object") cfg.files = parsed.files;
        return cfg;
      } catch {
        return $94557121a748c06f$var$defaultConfig();
      }
    }
    function $94557121a748c06f$var$save(cfg) {
      try {
        localStorage.setItem($94557121a748c06f$var$LS_KEY, JSON.stringify(cfg));
      } catch {}
    }
    let $94557121a748c06f$var$_config = typeof window !== "undefined" ? $94557121a748c06f$var$load() : {
      enabled: false
    };
    function $94557121a748c06f$var$_emit(filename, category, args) {
      if (!$94557121a748c06f$var$_config.enabled) return;
      if (!$94557121a748c06f$var$_config.categories[category]) return;
      if ($94557121a748c06f$var$_config.files[filename] === false) return;
      if ($94557121a748c06f$var$shouldGroupLog(filename, category)) {
        $94557121a748c06f$var$queueGroupedLog(filename, category, args);
        return;
      }
      const catStyle = $94557121a748c06f$var$CATEGORY_STYLES[category] ?? "color:#64748b;font-weight:bold";
      const prefix = `%c[DEBUG] %c[${category}] %c[${filename}]`;
      if (category === "errors") console.error(prefix, $94557121a748c06f$var$LABEL_STYLE, catStyle, $94557121a748c06f$var$FILE_STYLE, ...args); else console.log(prefix, $94557121a748c06f$var$LABEL_STYLE, catStyle, $94557121a748c06f$var$FILE_STYLE, ...args);
    }
    function $94557121a748c06f$var$shouldGroupLog(filename, category) {
      return $94557121a748c06f$var$GROUPED_LOG_RULES.some(rule => rule.file === filename && rule.category === category);
    }
    function $94557121a748c06f$var$groupedKey(filename, category) {
      return `${filename}::${category}`;
    }
    function $94557121a748c06f$var$queueGroupedLog(filename, category, args) {
      const key = $94557121a748c06f$var$groupedKey(filename, category);
      const buffer = $94557121a748c06f$var$groupedLogBuffers.get(key) || [];
      buffer.push(args);
      $94557121a748c06f$var$groupedLogBuffers.set(key, buffer);
      if ($94557121a748c06f$var$groupedLogTimers.has(key)) return;
      const timer = setTimeout(() => {
        $94557121a748c06f$var$groupedLogTimers.delete(key);
        $94557121a748c06f$var$flushGroupedLogs(filename, category);
      }, $94557121a748c06f$var$BATCH_WINDOW_MS);
      $94557121a748c06f$var$groupedLogTimers.set(key, timer);
    }
    function $94557121a748c06f$var$flushGroupedLogs(filename, category) {
      const key = $94557121a748c06f$var$groupedKey(filename, category);
      const buffer = $94557121a748c06f$var$groupedLogBuffers.get(key);
      if (!buffer || buffer.length === 0) return;
      $94557121a748c06f$var$groupedLogBuffers.delete(key);
      const catStyle = $94557121a748c06f$var$CATEGORY_STYLES[category] ?? "color:#64748b;font-weight:bold";
      const header = `%c[DEBUG] %c[${category}] %c[${filename}] %c(${buffer.length} logs batched)`;
      console.groupCollapsed(header, $94557121a748c06f$var$LABEL_STYLE, catStyle, $94557121a748c06f$var$FILE_STYLE, "color:#64748b");
      buffer.forEach(entryArgs => {
        console.log(...entryArgs);
      });
      console.groupEnd();
    }
    function $94557121a748c06f$var$createRealLogger(filename) {
      return function log(category, ...args) {
        $94557121a748c06f$var$_emit(filename, category, args);
      };
    }
    const $94557121a748c06f$export$fe2e61603b61130d = () => () => {};
    function $94557121a748c06f$export$46ff38bc6bdea8fb(error) {
      if (error instanceof Error) return {
        name: error.name,
        message: error.message,
        stack: error.stack
      };
      return {
        value: error
      };
    }
    function $94557121a748c06f$export$4ecc6b6d3cd743de(reason, details = {}) {
      return {
        reason: reason,
        ...details
      };
    }
    const $94557121a748c06f$export$282d649a8a633ddc = {
      start() {
        $94557121a748c06f$var$_config.enabled = true;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log("%c[DEBUG] Logging enabled. Reload the page for full coverage.", "color:#10b981;font-weight:bold");
        this.status();
      },
      stop() {
        $94557121a748c06f$var$_config.enabled = false;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log("%c[DEBUG] Logging disabled.", "color:#ef4444;font-weight:bold");
      },
      enable(category) {
        if (!$94557121a748c06f$var$CATEGORIES.includes(category)) {
          console.warn(`[DEBUG] Unknown category "${category}". Available: ${$94557121a748c06f$var$CATEGORIES.join(", ")}`);
          return;
        }
        $94557121a748c06f$var$_config.categories[category] = true;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] Category "${category}" enabled.`, "color:#10b981");
      },
      disable(category) {
        if (!$94557121a748c06f$var$CATEGORIES.includes(category)) {
          console.warn(`[DEBUG] Unknown category "${category}". Available: ${$94557121a748c06f$var$CATEGORIES.join(", ")}`);
          return;
        }
        $94557121a748c06f$var$_config.categories[category] = false;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] Category "${category}" disabled.`, "color:#f59e0b");
      },
      enableFile(file) {
        delete $94557121a748c06f$var$_config.files[file];
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] File "${file}" re-enabled.`, "color:#10b981");
      },
      disableFile(file) {
        $94557121a748c06f$var$_config.files[file] = false;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] File "${file}" disabled.`, "color:#f59e0b");
      },
      status() {
        const categoryRows = $94557121a748c06f$var$CATEGORIES.map(c => ({
          category: c,
          enabled: $94557121a748c06f$var$_config.categories[c] ? "✅" : "❌"
        }));
        const fileRows = Object.entries($94557121a748c06f$var$_config.files).map(([f, v]) => ({
          file: f,
          enabled: v ? "✅" : "❌"
        }));
        console.group("%c[DEBUG] Status", "color:#6366f1;font-weight:bold");
        console.log("Logging:", $94557121a748c06f$var$_config.enabled ? "%c enabled" : "%c disabled", $94557121a748c06f$var$_config.enabled ? "color:#10b981;font-weight:bold" : "color:#ef4444;font-weight:bold");
        console.log("localStorage key:", $94557121a748c06f$var$LS_KEY);
        console.table(categoryRows);
        if (fileRows.length) {
          console.log("File overrides:");
          console.table(fileRows);
        } else console.log("File overrides: none (all files active)");
        console.groupEnd();
      },
      reset() {
        localStorage.removeItem($94557121a748c06f$var$LS_KEY);
        $94557121a748c06f$var$_config = $94557121a748c06f$var$defaultConfig();
        console.log("%c[DEBUG] Settings cleared from localStorage.", "color:#f59e0b;font-weight:bold");
      },
      help() {
        console.group("%c[DEBUG] Available commands", "color:#6366f1;font-weight:bold");
        console.log([ "__debug.start()               — enable all logging", "__debug.stop()                — disable all logging", "__debug.status()              — show current config", '__debug.enable("category")    — enable a category', '__debug.disable("category")   — disable a category', `__debug.enable("…")           — categories: ${$94557121a748c06f$var$CATEGORIES.join(", ")}`, '__debug.enableFile("file")    — un-exclude a file', '__debug.disableFile("file")   — exclude a file from output', "__debug.reset()               — clear all settings from localStorage", "__debug.help()                — show this help" ].join("\n"));
        console.groupEnd();
      }
    };
  });
  parcelRegister("gjV2B", function(module, exports) {
    $parcel$export(module.exports, "debounce", function() {
      return $be1aaad8d43db719$export$61fc7d43ac8f84b0;
    });
    const $be1aaad8d43db719$export$61fc7d43ac8f84b0 = (func, wait) => {
      let timeout;
      const debounced = (...args) => {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
      debounced.cancel = () => {
        clearTimeout(timeout);
        timeout = null;
      };
      return debounced;
    };
  });
  var $cJzMp = parcelRequire("cJzMp");
  var $gjV2B = parcelRequire("gjV2B");
  var $176214806b49fe5c$export$2e2bcd8739ae039 = (() => {
    if (customElements.get("slider-component")) return;
    customElements.define("slider-component", class SliderComponent extends HTMLElement {
      constructor() {
        super();
        this._rawLogger = (0, $cJzMp.createLogger)("slider-component");
        this.isDebugEnabled = false;
        this.isSetup = false;
        this.isVisible = null;
        this.slideState = null;
        this.visibleSlideIndexes = new Set;
        this.markerObserver = null;
        this.displayObserver = null;
        this.controlsResizeObserver = null;
        this.controlsVisible = false;
        this.handleNext = this.handleNext.bind(this);
        this.handlePrevious = this.handlePrevious.bind(this);
        this._handleGoto = this._handleGoto.bind(this);
        this.checkControlsVisibility = (0, $gjV2B.debounce)(this.checkControlsVisibility.bind(this), 100);
      }
      log(topic, message, detail) {
        if (this.isDebugEnabled) this._rawLogger(topic, message, detail);
      }
      connectedCallback() {
        this.isDebugEnabled = this.hasAttribute("data-debug-enabled");
        this.slider = this.querySelector('[id^="Slider-"]');
        if (!this.slider) return;
        this.slides = Array.from(this.querySelectorAll("[data-slide]"));
        this.slideCounter = this.querySelector("[data-current-slide]");
        this.slideTotal = this.querySelector("[data-slide-total]");
        this.isWindowObserver = this.hasAttribute("data-window-observer");
        this.counterOffset = Number.parseInt(this.dataset.counterOffset || "0", 10);
        if (Number.isNaN(this.counterOffset)) this.counterOffset = 0;
        this.log("lifecycle", "connected", {
          sliderId: this.dataset.sliderId || null,
          hiddenDestroy: this.hasAttribute("data-hidden-destroy")
        });
        if (this.hasAttribute("data-hidden-destroy")) {
          const isInitiallyVisible = this.offsetWidth > 0 || this.offsetHeight > 0;
          this.isVisible = isInitiallyVisible;
          if (isInitiallyVisible) this.init();
          if (!this.displayObserver) this.setupDisplayObserver();
        } else this.init();
      }
      init() {
        this.log("lifecycle", "init", {
          sliderId: this.dataset.sliderId || null,
          slides: this.slides.length
        });
        if (this.isSetup) return;
        this.isSetup = true;
        this.setupScrollObserver();
        this.setupControlsResizeObserver();
      }
      setupScrollObserver() {
        if (this.markerObserver) return;
        this.markerObserver = this.createScrollObserver();
        for (const slide of this.slides) this.markerObserver.observe(slide);
        this.addEventListener("slider:goto", this._handleGoto);
        this.addEventListener("slider:get-state", e => {
          this.refreshSlides();
          if (this.slider && this.slider.clientWidth > 0) this.controlsVisible = this.slider.scrollWidth > this.slider.clientWidth;
          if (typeof e.detail?.callback === "function") e.detail.callback({
            ...this.slideState,
            controlsVisible: this.controlsVisible,
            canGoPrev: this._canGoPrev(),
            canGoNext: this._canGoNext()
          });
        });
        this.addEventListener("slider:next", this.handleNext);
        this.addEventListener("slider:previous", this.handlePrevious);
        this.dispatchSliderInit();
      }
      _handleGoto(e) {
        const {index: index} = e.detail;
        if (typeof index !== "number") return;
        const slide = this.slides[index];
        if (slide) this.slider.scrollTo({
          left: slide.offsetLeft,
          behavior: "smooth"
        });
      }
      dispatchSliderInit() {
        const detail = {
          activeIndex: 0,
          total: this.slides.length + this.counterOffset,
          controlsVisible: this.controlsVisible,
          canGoPrev: this._canGoPrev(),
          canGoNext: this._canGoNext()
        };
        this.slideState = detail;
        if (this.slideTotal) this.slideTotal.textContent = detail.total;
        this.dispatchEvent(new CustomEvent("slider:init", {
          detail: detail,
          bubbles: true
        }));
        this.emitControlsState();
      }
      dispatchSliderChange(activeIndex) {
        const detail = {
          activeIndex: activeIndex,
          total: this.slides.length + this.counterOffset,
          controlsVisible: this.controlsVisible,
          canGoPrev: this._canGoPrev(),
          canGoNext: this._canGoNext()
        };
        this.slideState = detail;
        this.dispatchEvent(new CustomEvent("slider:change", {
          detail: detail,
          bubbles: true
        }));
        this.emitControlsState();
      }
      refreshSlides() {
        const currentSlides = Array.from(this.querySelectorAll("[data-slide]"));
        if (currentSlides.length === this.slides.length) return;
        this.slides = currentSlides;
        if (this.markerObserver) {
          this.markerObserver.disconnect();
          this.visibleSlideIndexes.clear();
          for (const slide of this.slides) this.markerObserver.observe(slide);
        }
      }
      checkControlsVisibility() {
        if (!this.slider || this.slider.clientWidth < 1) return;
        this.refreshSlides();
        const needsScrolling = this.slider.scrollWidth > this.slider.clientWidth;
        this.controlsVisible = needsScrolling;
        this.log("ui", "checkControlsVisibility", {
          sliderId: this.dataset.sliderId || null,
          needsScrolling: needsScrolling
        });
        this.emitControlsState();
      }
      setupControlsResizeObserver() {
        if (this.controlsResizeObserver) return;
        this.controlsResizeObserver = new ResizeObserver(() => this.checkControlsVisibility());
        this.controlsResizeObserver.observe(this.slider);
        this.controlsResizeObserver.observe(this);
        this.checkControlsVisibility();
      }
      handleNext() {
        if (!this.slider) return;
        const movement = this.slides[0]?.clientWidth * Number(getComputedStyle(this).getPropertyValue("--movement_columns") || 1);
        if (!isNaN(movement)) this.slider.scrollTo({
          left: this.slider.scrollLeft + movement,
          behavior: "smooth"
        });
      }
      handlePrevious() {
        if (!this.slider) return;
        const movement = this.slides[0]?.clientWidth * Number(getComputedStyle(this).getPropertyValue("--movement_columns") || 1);
        if (!isNaN(movement)) this.slider.scrollTo({
          left: this.slider.scrollLeft - movement,
          behavior: "smooth"
        });
      }
      _canGoPrev() {
        if (!this.slides.length || !this.controlsVisible) return false;
        if (this.visibleSlideIndexes.size) return !this.visibleSlideIndexes.has(0);
        return this.slider.scrollLeft > 1;
      }
      _canGoNext() {
        if (!this.slides.length || !this.controlsVisible) return false;
        if (this.visibleSlideIndexes.size) return !this.visibleSlideIndexes.has(this.slides.length - 1);
        return this.slider.scrollLeft + this.slider.clientWidth < this.slider.scrollWidth - 1;
      }
      emitControlsState() {
        this.log("events", "emitControlsState", {
          sliderId: this.dataset.sliderId || null,
          controlsVisible: this.controlsVisible,
          canGoPrev: this._canGoPrev(),
          canGoNext: this._canGoNext(),
          activeIndex: this.slideState?.activeIndex ?? 0
        });
        this.dispatchEvent(new CustomEvent("slider:controls-state", {
          detail: {
            activeIndex: this.slideState?.activeIndex ?? 0,
            total: this.slideState?.total ?? this.slides.length + this.counterOffset,
            controlsVisible: this.controlsVisible,
            canGoPrev: this._canGoPrev(),
            canGoNext: this._canGoNext()
          },
          bubbles: true
        }));
      }
      updateSlideCounter(index) {
        if (this.slideCounter) this.slideCounter.textContent = index + 1 + this.counterOffset;
      }
      createScrollObserver() {
        return new IntersectionObserver(entries => {
          for (const entry of entries) {
            const index = this.slides.indexOf(entry.target);
            if (index === -1) continue;
            entry.isIntersecting ? this.visibleSlideIndexes.add(index) : this.visibleSlideIndexes.delete(index);
          }
          if (this.visibleSlideIndexes.size === 0) return;
          const lastIdx = this.slides.length - 1;
          const displayIdx = this.visibleSlideIndexes.has(lastIdx) ? lastIdx : Math.min(...this.visibleSlideIndexes);
          this.updateSlideCounter(displayIdx);
          this.dispatchSliderChange(displayIdx);
        }, {
          root: this.isWindowObserver ? null : this.slider,
          threshold: .95
        });
      }
      setupDisplayObserver() {
        this.displayObserver = new ResizeObserver(entries => {
          const isNowVisible = entries[0].contentRect.width > 0;
          if (this.isVisible !== isNowVisible) {
            isNowVisible ? this.init() : this.destroy();
            this.isVisible = isNowVisible;
          }
        });
        this.displayObserver.observe(this);
      }
      destroy() {
        this.isSetup = false;
        this.removeEventListener("slider:goto", this._handleGoto);
        this.removeEventListener("slider:next", this.handleNext);
        this.removeEventListener("slider:previous", this.handlePrevious);
        if (this.markerObserver) {
          this.markerObserver.disconnect();
          this.markerObserver = null;
        }
        if (this.controlsResizeObserver) {
          this.controlsResizeObserver.disconnect();
          this.controlsResizeObserver = null;
        }
        this.controlsVisible = false;
        this.emitControlsState();
      }
      disconnectedCallback() {
        this.destroy();
        this.displayObserver?.disconnect();
      }
    });
  })();
})();